<template>
    <div class="mb-4 slim">
        <h3 class="block-title text-center" v-if="content.meta.title"><span class="block-title-content theme-tinted-border">{{this.content.meta.title}}</span></h3>
        <div class="members-wrapper">
            <div v-for="member in members" class="member-item col-12 col-sm-6 col-md-4 col-lg-3">
                <content-unit
                    :outerWrapperClass="''"
                    :key="member.contentUnit.id"
                    :enableCrop="false"
                    :context="context"
                    :providerId="context.providerId"
                    :providerInformationBlockId="block.id"
                    :contentUnit="member.contentUnit">

                    <div slot="template" slot-scope="props">
                        <img class="member-avatar-image" v-if="props.thumbnailUrl || props.imageUrl || props.imageData"
                            :src="props.imageData ? props.imageData : (props.thumbnailUrl || props.imageUrl)" />
                        <div class="member-avatar-image-empty" v-else></div>
                    </div>
                </content-unit>

                <div class="member-info mt-4">
                    <div class="member-name">{{member.name}}</div>
                    <p class="member-content" v-html="member.content"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['block', 'providerId', 'context'],

        data: function() {
            var content = JSON.parse(this.block.content);
            if (!content.members) {
                content.members = [];
            }

            return {
                id: this.block.id,
                content: content,
                informationBlock: this.block.information_block,
                members: content.members,
            };
        },
    }
</script>

<style>

    .member-info .member-content a {
        word-break: break-all;
    }

</style>

<style scoped>
    .members-wrapper {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    .member-item {
        display: inline-flex;
        flex-direction: column;
        position: relative;
        align-items: center;
        margin-top: 2em;
        text-align: center;
    }

    .member-info {
        padding: 0 12px;
        position: relative;
    }

    .member-info .member-name {
        font-size: 18px;
        font-weight: bold;
    }

    .member-info .member-content {
        font-size: 16px;
        text-align: left;
        white-space: pre-wrap;
        word-break: break-all;
    }

    @media only screen and (max-width: 1280px) {
        .member-item {
            width: 50%;
        }
    }

    @media only screen and (max-width: 600px) {
        .member-item {
            width: 100%;
        }
    }

    .member-avatar-image{
        flex-grow: 0;
        width: 128px;
        height: 128px;
        border-radius: 64px;
        overflow: hidden;
        cursor: pointer;
    }

    .member-avatar-image-empty {
        flex-grow: 0;
        width: 128px;
        height: 128px;
        border-radius: 64px;
        overflow: hidden;
        background: #ccc;
        border-radius: 64px;
        padding-bottom: 0px;
        color: white;
        cursor: pointer;
    }
</style>
